export default {
    Unknown: {
        id: "0",
        label: 'Unknown',
        translationKey: 'unknown'
    },
    CustomSetting: {
        id: "1",
        label: 'Custom Setting',
        translationKey: 'customSetting'
    },
    InheritPreset: {
        id: "2",
        label: 'Inherited from Parent',
        translationKey: 'inheritedFromParent'
    }
};
